import DeleteSliderModal from "./deleteSliderModal";

export default DeleteSliderModal;
